import { useQuery } from '@tanstack/react-query'
import { useFormContext } from 'react-hook-form'

import { useApi } from '@fortem-monorepo/react-spa'
import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface CounterpartyIdFieldProps {}

export const CounterpartyIdField: React.FC<CounterpartyIdFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ counterparty_id: number }>()

  const api = useApi()

  const { data, isFetching } = useQuery({
    queryKey: ['static/banks'],
    queryFn: () => api.misc.getBanks(),
  })

  return (
    <FormField
      name="counterparty_id"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>Counterparty</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              loading={isFetching}
              className={'flex flex-1 min-w-auto!'}
              placeholder={'Select a counterparty...'}
              value={value?.toString()}
              setValue={(value) =>
                setValue('counterparty_id', parseInt(value), { shouldValidate: true })
              }
              options={(data ?? []).map((bank) => ({
                label: bank.label,
                value: bank.value?.toString(),
              }))}
            />
          </FormItem>
        )
      }}
    />
  )

  return <></>
}
